<script>
  export default {
    functional: true,

    name: 'UiCardActions',

    render (h, {data, children} ) {
      const staticClass = 'card-actions';
      data.staticClass = data.staticClass ? `${data.staticClass} ${staticClass}` : staticClass;
      children.forEach(child => {
        if (child.tag === 'button') {
          child.data.staticClass += 'card-action'
        }
      });

      return h('section', {
        ...data
      }, children)
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/UiCardActions.vue